import { createApi } from '@reduxjs/toolkit/dist/query/react';
import baseQuery from '../../functions/baseQuery';

export const userTag = 'user' as const;
export const checkUserTag = 'checkUser' as const;
export const regionTag = 'region' as const;
export const driverTag = 'driver' as const;
export const organizationTag = 'organization' as const;
export const driverDocumentsTag = 'driverDocuments' as const;
export const documentReviewTag = 'documentReview' as const;
export const candidatesListTag = 'candidatesListTag' as const;
export const candidateDocumentsListTag = 'candidateDocumentsListTag' as const;
export const currentDriverInfoTag = 'currentDriverInfoTag' as const;
export const featureFlagTag = 'feature-flag' as const;

const tagTypes = [
  userTag,
  checkUserTag,
  regionTag,
  driverTag,
  organizationTag,
  driverDocumentsTag,
  documentReviewTag,
  candidatesListTag,
  candidateDocumentsListTag,
  currentDriverInfoTag,
  featureFlagTag,
] as const;

export const apiService = createApi({
  baseQuery,
  reducerPath: 'apiService',
  tagTypes: tagTypes,
  endpoints: () => ({}),
});
